'use strict'

import axios from 'axios'

const { VUE_APP_CONTENT_URL } = process.env

export default async jwt => {
  const response = await axios({
    method: 'get',
    headers: {
      Authorization: jwt
    },
    url: `${VUE_APP_CONTENT_URL}/shoppe/subscription`,
    timeout: 8000
  })

  return response.data
}
